import store from '@/store/store';

const formConfig = [
    {
        companyName: 'Furness Underwriting Europe',
        logoPath: 'logos/fur-coloured.svg',
        sections: [
            {   
                sectionName: 'Portfolio Analysis',
                reports: [
                    {
                        reportName: 'Production',
                        reportType: 1,
                        class: 'sm:w-1/4 w-full',
                        fields: [
                            {
                                type: 'select',
                                placeHolder: 'Select period',
                            },
                        ],
                    },
                    {
                        reportName: 'Renewals',
                        reportType: 2,
                        class: 'sm:w-1/4 w-full',
                        fields: [
                            {
                                type: 'text',
                                value: 'Next 3 months',
                            },
                        ],
                    },
                    {
                        reportName: 'Statement of Accounts',
                        reportType: 3,
                        class: 'sm:w-1/4 w-full',
                        fields: [
                            {
                                type: 'text',
                                value: 'Last report',
                            },
                        ],
                    },
                    {
                        reportName: 'Claim Bordereau',
                        reportType: 4,
                        class: 'sm:w-1/4 w-full',
                        fields: [
                            {
                                type: 'text',
                                value: 'Last report',
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
      companyName: 'International Professional Risks Europe',
      logoPath: 'logos/int-coloured.svg',
      sections: [
            {
                sectionName: 'Facultative / Open Market Analysis',
                personaSectionName: 'facultative-open-market-analysis',
                reports: [
                    {
                        reportName: 'Production',
                        reportType: 5,
                        class: 'sm:w-1/4 w-full',
                        fields: [
                            {
                                type: 'select',
                                placeHolder: 'Select period',
                            },
                        ],
                    },
                    {
                        reportName: 'Renewals',
                        reportType: 6,
                        class: 'sm:w-1/4 w-full',
                        fields: [
                            {
                                type: 'text',
                                value: 'Next 3 months',
                            },
                        ],
                    },
                    {
                        reportName: 'Statement of Accounts',
                        reportType: 7,
                        class: 'sm:w-1/4 w-full',
                        fields: [
                            {
                                type: 'text',
                                value: 'Last report',
                            },
                        ],
                    },
                    {
                        reportName: 'Claim Bordereau',
                        reportType: 8,
                        class: 'sm:w-1/4 w-full',
                        fields: [
                            {
                                type: 'text',
                                value: 'Last report',
                            },
                        ],
                    },
                ],
            },
            {
                sectionName: 'Delegated Underwriting Authority (DUA)',
                personaSectionName: 'dua',
                reports: [
                    {
                        reportName: 'Status Report',
                        reportType: 13,
                        class: 'lg:w-1/2 w-full large-field',
                        fields: [
                            {
                                type: 'text',
                                value: 'Last Report',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select Coverholder',
                                dropdownOptionsType: 'CoverholderList',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select facility',
                                dropdownOptionsType: 'BindersList',
                                dependency: 'CoverholderList',
                            },
                        ],
                    },
                    {
                        reportName: 'Claim Bordereau',
                        reportType: 16,
                        class: 'lg:w-1/2 w-full large-field',
                        fields: [
                            {
                                type: 'text',
                                value: 'Last Report',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select Coverholder',
                                dropdownOptionsType: 'CoverholderList',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select facility',
                                dropdownOptionsType: 'BindersList',
                                dependency: 'CoverholderList',
                            },
                        ],
                    },
                    {
                        reportName: 'Claims Triangulations',
                        reportType: 17,
                        class: 'lg:w-1/2 w-full large-field',
                        fields: [
                            {
                                type: 'text',
                                value: 'Last Report',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select Coverholder',
                                dropdownOptionsType: 'CoverholderList',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select facility',
                                dropdownOptionsType: 'BindersList',
                                dependency: 'CoverholderList',
                            },
                        ],
                    },
                    {
                        reportName: 'Risk Bordereaux – DDM template',
                        reportPersonaName: 'risk-bordereaux{dash}ddm-template',
                        reportType: 14,
                        class: 'lg:w-1/2 w-full large-field',
                        fields: [
                            {
                                type: 'select',
                                placeHolder: 'Select period',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select Coverholder',
                                dropdownOptionsType: 'CoverholderList',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select facility',
                                dropdownOptionsType: 'BindersList',
                                dependency: 'CoverholderList',
                            },
                        ],
                    },
                    {
                        reportName: 'Premium Bordereaux – DDM template',
                        reportPersonaName: 'premium-bordereaux{dash}ddm-template',
                        reportType: 15,
                        class: 'lg:w-1/2 w-full large-field',
                        fields: [
                            {
                                type: 'select',
                                placeHolder: 'Select period',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select Coverholder',
                                dropdownOptionsType: 'CoverholderList',
                            },
                            {
                                type: 'select',
                                placeHolder: 'Select facility',
                                dropdownOptionsType: 'BindersList',
                                dependency: 'CoverholderList',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

const specialCharaters = {
    '{dash}': ' - ',
    '{fslash}': ' / ',
    '{bslash}': ' \ ',
    '{colon}': ': ',
    '{semicolon}': '; ',
};

export const formMap = () => {
    const privileges = store.getters['personas/privileges'];
    const filteredSections = [];
    
    formConfig.forEach(company => {
        company.sections = company.sections.filter(section => {
            let sectionName = section.personaSectionName || section.sectionName;

            section.reports = section.reports.filter(report => {
                const reportName = report.reportPersonaName || report.reportName;
                const personaName = `${sectionName}_${reportName}`.toLowerCase().replace(/\s/g, '-');

                Object.keys(specialCharaters).forEach((character) => {
                    if (personaName.includes(character)) {
                        personaName.replace(character, specialCharaters[character])
                    }
                })

                const hasAccess = privileges.find((navAccessItem) => navAccessItem.PageName === personaName);

                return (hasAccess && hasAccess.View);
            })

            return section.reports.length;
        });

        if (company.sections.length) {
            filteredSections.push(company);
        }
    });

    return filteredSections;
}